import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Users } from 'my-lib-sanfelici/my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';
import { NewMapsDialogViewComponent } from '../../new-maps/new-maps-dialog-view/new-maps-dialog-view.component';



@Component({
  selector: 'app-ditta-form',
  templateUrl: './ditta-form.component.html',
  styleUrls: ['./ditta-form.component.scss']
})
export class DittaFormComponent implements OnInit {
  @Input() user: Users;

  constructor(
    public dialog: MatDialog,
    private usersservice: UsersService) { }
    openDialog(): void {
      const dialogRef = this.dialog.open(NewMapsDialogViewComponent, {

      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        console.log(result);
        if (result) {
          this.user.ditta.address = result;

        }
      });
    }

  ngOnInit() {
    if (this.user) {
      if (this.user.ditta) {

      } else {
        this.user.ditta = {
          ragionesociale: null,
          codicefiscale: null,
          partitaiva: null,
          address: null
        }
      }
    }
  }

}
